import { ISessionService, SessionCreatedEvent } from '@studyportals/student-interfaces';
import store from '../store';
import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';

export class SessionAdapter implements ISubscriber<SessionCreatedEvent> {
	private sessionService: ISessionService;
	private eventAggregationService: IEventAggregationService;

	constructor(sessionService: ISessionService, eventAggregationService: IEventAggregationService) {
		this.eventAggregationService = eventAggregationService;
		this.sessionService = sessionService;
	}

	public async initialize(): Promise<void> {
		await this.handleSessionService(this.sessionService);
		this.eventAggregationService?.subscribeTo(SessionCreatedEvent.EventType, this);
	}

	public notify(): void {
		store.mutations.setLoggedInFlag(true);
	}

	private async handleSessionService(sessionService: ISessionService): Promise<void> {
		const session: object | null = await sessionService.getSession();

		if (session === null) {
			store.mutations.setLoggedInFlag(false);
			return;
		}

		store.actions.userLoggedIn();
	}
}
